<script>
  import GenerateLedgers from '../views/GenerateLedgers.svelte'
</script>

<GenerateLedgers />

<section class="box">
  <h1>作業日報</h1>
  <a href="/report-summary"
    >＞＞ 作業日報サマリーへ移動するにはここをクリック ＜＜</a
  >
</section>

<section class="box">
  <h1>
    月次 走行記録
    <span class="icon">
      <i class="fas fa-lock" />
    </span>
  </h1>
  <a href="/monthly-route-logs?role=manager"
    >＞＞ 管理者モードの月次 走行記録へ移動するにはここをクリック ＜＜</a
  >
</section>

<hr />
